module.exports = __webpack_public_path__ + "static/media/in-the-beginning-was-the-word.ff8eeaf4.txt";